import {Backend} from "../index.js";

export type parentBackendRequest = (func: string, args?: any[]) => Promise<any>;

/**
 * Instead of calling pn-api, ParentBackend sends messages to a parent instance, which will handle the requests.
 * The function that actually sends the messages needs to be passed as an argument to the constructor.
 */
// @ts-ignore - We implement the Backend interface by using Proxy to call methods dynamically.
// Thanks: https://stackoverflow.com/a/42244695/368864
export default class ParentBackend implements Backend {
	constructor(requestFn: parentBackendRequest) {
		return new Proxy(this, {
			get: (object: ParentBackend, func: string) =>
				(...args: any[]) => requestFn(func, args)
		});
	}
}
